import { render, staticRenderFns } from "./TabelaResumoValidacoes.vue?vue&type=template&id=07b5b762&"
import script from "./TabelaResumoValidacoes.vue?vue&type=script&lang=js&"
export * from "./TabelaResumoValidacoes.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResumoValidacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
